import { ReactComponent as Requested } from '@/assets/images/layout/requested.svg';
import { ReactComponent as Preparing } from '@/assets/images/layout/preparing.svg';
import { ReactComponent as History } from '@/assets/images/layout/history.svg';
import { ReactComponent as Mypage } from '@/assets/images/layout/mypage.svg';
import { ReactComponent as Notice } from '@/assets/images/layout/notice.svg';
import { ReactComponent as Service } from '@/assets/images/layout/service.svg';
import { ReactComponent as Medicine } from '@/assets/images/layout/medicineIcon.svg';
export interface NavType {
  name: string;
  sub?: Array<SubNavType>;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  path: string;
  noti?: string;
}

export interface SubNavType {
  name: string;
  path: string;
}

export const NavList: Array<NavType> = [
  {
    name: '조제 접수',
    Icon: Requested,
    path: '/requested',
    noti: 'requested'
  },
  {
    name: '조제 진행',
    Icon: Preparing,
    path: '/preparing',
    noti: 'preparing'
  },
  {
    name: '결제 내역',
    Icon: History,
    path: '/history'
  },
  {
    name: '마이페이지',
    Icon: Mypage,
    path: '/mypage'
  },
  {
    name: '약품 관리',
    Icon: Medicine,
    path: '/medicine'
  },
  {
    name: '공지사항',
    Icon: Notice,
    path: '/notice'
  },
  {
    name: '서비스 문의',
    Icon: Service,
    path: '/service'
  }
];
